// extracted by mini-css-extract-plugin
export default {"overlay":"MobileModal_overlay__0BeCv","modal":"MobileModal_modal__ZwWm8","slideUp":"MobileModal_slideUp__wwyGk","closeBtn":"MobileModal_closeBtn__39xNc"};